<template>
    <rkm-form
        show-legend
    >
        <CidadaoBusca
            ref="CidadaoBusca"
            :termos-invalidos="form.termosInvalidos"
            :data-atual="form.dataAtual"
            :on-continue="onContinue"
            show-usuarios
            @searching="$emit('searching', $event)"
            @form-change="$emit('form-change', $event)"
            @select-cidadao="$emit('select-cidadao', $event)"
            @select-usuario="$router.push({ name: 'cadastro-usuario-edit', params: { id: $event.id } })"
        />
    </rkm-form>
</template>

<script>
import CidadaoBusca from '@/components/cadastro/cidadao/Busca'

export default {
    components: { CidadaoBusca },
    props: {
        form: { type: Object, required: true },
        onContinue: { type: Function, required: true },
    },
    methods: {
        validate() {

            return this.$refs.CidadaoBusca.validate()
        },
        reset() {

            this.$refs.CidadaoBusca.resetForms()
        },
    }
}
</script>